module.exports = __webpack_public_path__ + "img/plan_point_badge_2.376f77d0.png";